<template>
        <div class="flex justify-center mb-1 flags">
            <div v-for="lang in $page.props.languages" class="w-24 px-2">
                <img class="h-full rounded-lg" :class="selectedLang.includes(lang.code)?'':' grayscale'"
                     :src="lang.flagFile" @click="selectLanguage(lang.code)">
            </div>
        </div>

        <div class="mb-4">
        <label for="fallback_lang">
          Fallback language
        </label>
        <select @change="setFallbackLanguage" v-model="fallbackLang" name="fallback_lang">
            <option v-for="(lang, index) in languages" :key="index"
            :value="lang.code">{{ lang.name }}</option>
        </select>
        </div>

        <!-- Tour name -->
        <div v-for="(el, index) in dynamicTourName.filter(el => el.show)" :key="index" class="mb-4">
        <label>
          {{ el.label }}
        </label>
        <input v-model="el.value" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" :placeholder="el.label">
        </div>
        <!-- Tour name -->
</template>

<script>

export default {
    //pass actual state to global object
    mounted() {
        this.$page.props.newTourData = {};
        this.$page.props.newTourData.selectedLang = this.selectedLang;
        this.$page.props.newTourData.fallbackLang = this.fallbackLang;
        this.$page.props.newTourData.dynamicTourName = this.dynamicTourName;
    },
    updated() {
        this.$page.props.newTourData = {};
        this.$page.props.newTourData.selectedLang = this.selectedLang;
        this.$page.props.newTourData.fallbackLang = this.fallbackLang;
        this.$page.props.newTourData.dynamicTourName = this.dynamicTourName;
        this.$page.props.newTourData.errors = {};
        this.$page.props.newTourData.errors.tourName = false;
    },
    computed: {
        dynamicTourName() {
            return this.$page.props.languages.map(x => ({
                lang: x['code'],
                label: x['nameQuestionInTourCreateModal'],
                show: this.selectedLang[0] === x['code'],
                value: x['value'],
            }));
        },
    },
    data() {
        return {
            languages: this.$page.props.languages,
            selectedLang: [this.$page.props.languages[0].code],
            fallbackLang: this.$page.props.languages[0].code,
        }
    },

    methods: {

        selectLanguage(lang){
            if(this.selectedLang.includes(lang)){
                //disable removing fallback language
                if(lang === this.fallbackLang){
                    return;
                }
                this.selectedLang = this.selectedLang.filter(el => el !== lang);
                //hide input according to language
                this.dynamicTourName.map(el => {
                    if(el.lang === lang) {
                        el.show = false;
                    }
                });

            } else {
                this.selectedLang.push(lang);
                //show input according to language
                this.dynamicTourName.map(el => {
                    if(el.lang === lang) {
                        el.show = true;
                    }
                });
            }
        },
        setFallbackLanguage(e){
            const lang = e.target.value;
            this.selectedLang = [lang];
            this.dynamicTourName = this.dynamicTourName.map(el => {
                if(el.lang === lang) {
                    return el.show = true;
                }
                return el.show = false;
            });
        }

    },
}
</script>
